<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <center>
                                <h4 v-html="add_h4_1[getCurrentLocale]"></h4>
                            </center>


                            <br /><br />
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th v-html="add_th_1[getCurrentLocale]"></th>
                                        <th v-html="add_th_2[getCurrentLocale]"></th>
                                        <th v-html="add_th_3[getCurrentLocale]"></th>
                                    </tr>
                                    <tr>
                                        <th v-html="add_th_4[getCurrentLocale]"></th>
                                        <th>&nbsp;</th>
                                        <th v-html="add_th_5[getCurrentLocale]"></th>
                                        <th v-html="add_th_6[getCurrentLocale]"></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <th scope="row" v-html="add_row_1_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_1_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_1_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_1_4[getCurrentLocale]">/td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_2_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_2_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_2_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_2_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_3_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_3_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_3_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_3_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_4_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_4_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_4_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_4_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_5_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_5_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_5_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_5_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_6_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_6_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_6_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_6_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_7_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_7_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_7_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_7_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_8_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_8_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_8_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_8_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_9_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_9_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_9_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_9_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_10_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_10_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_10_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_10_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_11_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_11_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_11_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_11_4[getCurrentLocale]"></td>
                                    </tr>





                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_12_1[getCurrentLocale]"><b></b></th>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_13_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_13_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_13_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_13_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_14_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_14_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_14_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_14_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_15_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_15_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_15_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_15_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_16_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_16_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_16_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_16_4[getCurrentLocale]"></td>
                                    </tr>





                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_17_1[getCurrentLocale]"></th>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_18_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_18_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_18_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_18_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_19_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_19_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_19_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_19_4[getCurrentLocale]"></td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_20_1[getCurrentLocale]"></th>
                                        <td v-html="add_row_20_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_20_3[getCurrentLocale]"></td>
                                        <td v-html="add_row_20_4[getCurrentLocale]"></td>
                                    </tr>





                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_21_1[getCurrentLocale]"></th>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td v-html="add_row_22_1[getCurrentLocale]"></td>
                                        <td v-html="add_row_22_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_22_3[getCurrentLocale]"></td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td v-html="add_row_23_1[getCurrentLocale]"></td>
                                        <td v-html="add_row_23_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_23_3[getCurrentLocale]"></td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td v-html="add_row_24_1[getCurrentLocale]"></td>
                                        <td v-html="add_row_24_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_24_3[getCurrentLocale]"></td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td v-html="add_row_25_1[getCurrentLocale]"></td>
                                        <td v-html="add_row_25_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_25_3[getCurrentLocale]"></td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td v-html="add_row_26_1[getCurrentLocale]"></td>
                                        <td v-html="add_row_26_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_26_3[getCurrentLocale]"></td>
                                        <td>&nbsp;</td>
                                    </tr>





                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" v-html="add_row_27_1[getCurrentLocale]"></th>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td v-html="add_row_28_1[getCurrentLocale]"></td>
                                        <td v-html="add_row_28_2[getCurrentLocale]"></td>
                                        <td v-html="add_row_28_3[getCurrentLocale]"></td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>



                            <br /><br />
                            <p v-html="add_p_1[getCurrentLocale]"></p>
                            <p v-html="add_p_2[getCurrentLocale]"></p>
                            <p v-html="add_p_3[getCurrentLocale]"></p>
                            <p v-html="add_p_4[getCurrentLocale]"></p>



                            <br /><br /><br />
                            <p v-html="add_footer_1[getCurrentLocale]"></p>
                            <br />
                            <p>Update: 02.11.2020</p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Charges for additional services',
                    de: 'Entgelte für Zusatzleistungen',
                },
                // >>> ------------------------
                add_h4_1 : {
                    en: 'Charges for additional services<br />Valid for all flights effective from 02.11.2020 (subject to changes)',
                    de: 'Entgelte für Zusatzleistungen<br />Gültig für alle Flüge ab 02.11.2020 (Vorbehaltlich Änderungen)',
                },
                // >>> ------------------------
                add_th_1: {
                    en: 'Information',
                    de: 'Hinweise',
                },
                add_th_2: {
                    en: 'Charges for additional services<br />- online reservation',
                    de: 'Entgelt bei Online-Reservierung',
                },
                add_th_3: {
                    en: 'Charges for additional services<br />- check-in counter',
                    de: 'Entgelt am Check-in',
                },
                add_th_4: {
                    en: 'Baggage',
                    de: 'Gepäck',
                },
                add_th_5: {
                    en: 'Charges per flight',
                    de: 'Gebühren je Strecke',
                },
                add_th_6: {
                    en: 'Charges per flight',
                    de: 'Gebühren je Strecke',
                },
                // >>> ------------------------
                add_row_1_1: {
                    en: 'Excess Baggage',
                    de: 'Übergepäck',
                },
                add_row_1_2: {
                    en: 'Registration > 5 kg recommended',
                    de: 'Anmeldung ab 5 kg empfohlen',
                },
                add_row_1_3: {
                    en: '10 EUR per kg',
                    de: '10 EUR je kg',
                },
                add_row_1_4: {
                    en: '15 EUR per kg',
                    de: '15 EUR je kg',
                },
                // >>> ------------------------
                add_row_2_1: {
                    en: 'Bicycle',
                    de: 'Fahrrad',
                },
                add_row_2_2: {
                    en: 'Registration required; up to one (1) piece of luggage;<br /> maximum 20 kg; any weight exceeded be charged as excess baggage.<br /><br /><b>ATTENTION:</b> bicycles with electric drive (Li-batteries / rechargeable batteries) are not allowed to be transported as sport and special luggage.<br /> Sports luggage must be opened at check-in.<br /> Fees for sports and special baggage are non-refundabled.',
                    de: 'anmeldepflichtig; maximal ein (1) Gepäckstück;<br /> maximal 20 kg; ab 21. kg Übergepäckrate.<br /><br /><b>ACHTUNG:</b> Fahrräder mit Elektroantrieb (Li-Batterien/Akkus) dürfen nicht als Sport- und Sondergepäck transportiert werden.<br /> Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.',
                },
                add_row_2_3: {
                    en: '65 EUR',
                    de: '65 EUR',
                },
                add_row_2_4: {
                    en: '120 EUR',
                    de: '120 EUR',
                },
                // >>> ------------------------
                add_row_3_1: {
                    en: 'Golf equipment',
                    de: 'Golfgepäck',
                },
                add_row_3_2: {
                    en: 'Registration required; up to one (1) piece of luggage;<br />  maximum 20 kg; any weight exceeded be charged as excess baggage;<br />  must be packed separately;<br /> ; may <u> only</u> include golf equipment.<br /><br /><b>ATTENTION:</b> Golf trolleys with electric drive (Li-batteries / rechargeable batteries) are not allowed to be transported as sport or special luggage.<br /> Sports luggage must be opened at check-in.<br />Fees for sports and special baggage are non-refundable.',
                    de: 'anmeldepflichtig; maximal ein (1) Gepäckstück;<br /> maximal 20 kg; ab 21. kg Übergepäckrate; muss separat gepackt sein;<br />  darf <u>ausschließlich</u> Golf-Equipment beinhalten.<br /><br /><b>ACHTUNG:</b> Golftrolleys mit Elektroantrieb (Li-Batterien/Akkus) dürfen nicht als Sport-oder Sondergepäck transportiert werden. <br />Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig. ',
                },
                add_row_3_3: {
                    en: '65 EUR',
                    de: '65 EUR',
                },
                add_row_3_4: {
                    en: '120 EUR',
                    de: '120 EUR',
                },
                // >>> ------------------------
                add_row_4_1: {
                    en: 'Diving equipment',
                    de: 'Tauchgepäck',
                },
                add_row_4_2: {
                    en: 'Registration required, up to one (1) piece of luggage;<br />  maximum 30 kg; any weight exceeded be charged as excess baggage; must be packed separately; may only include diving equipment.<br /> Sports luggage must be opened at check-in. Fees for sports and special baggage are non-refundable.<br /><br /><b>ATTENTION:</b> Diving lamps are dangerous goods; therefore a separate registration isrequired.',
                    de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 30 kg; ab 31. kg Übergepäckrate; muss separat gepackt sein; darf <u>ausschließlich</u> Tauch-Equipment beinhalten.<br />Sportgepäck muss am Check-in geöffnet werden. Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.<br /><br /><b>ACHTUNG:</b> Tauchlampen sind Gefahrgut; aufgrund dessen ist eine separate Anmeldung erforderlich.',
                },
                add_row_4_3: {
                    en: '65 EUR',
                    de: '65 EUR',
                },
                add_row_4_4: {
                    en: '120 EUR',
                    de: '120 EUR',
                },
                // >>> ------------------------
                add_row_5_1: {
                    en: 'Diving equipment',
                    de: 'Tauchgepäck',
                },
                add_row_5_2: {
                    en: 'Registration required, up to one (1) piece of luggage;<br /> maximum 20 kg; any weight exceeded be charged as excess baggage; must be packed separately; may only include diving equipment.<br /> Sports luggage must be opened at check-in. Fees for sports and special baggage are non-refundable.<br /><br /><b>ATTENTION:</b> Diving lamps are dangerous goods; therefore a separate registration isrequired.',
                    de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 20 kg; ab 21. kg Übergepäckrate; muss separat gepackt sein; darf <u>ausschließlich</u> Tauch-Equipment beinhalten.<br />Sportgepäck muss am Check-in geöffnet werden. Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.<br /><br /><b>ACHTUNG:</b> Tauchlampen sind Gefahrgut; aufgrund dessen ist eine separate Anmeldung erforderlich.',
                },
                add_row_5_3: {
                    en: '40 EUR',
                    de: '40 EUR',
                },
                add_row_5_4: {
                    en: '100 EUR',
                    de: '100 EUR',
                },
                // >>> ------------------------
                add_row_6_1: {
                    en: 'Surf/Wave/Kiteboard',
                    de: 'Surf/Wave/Kiteboard',
                },
                add_row_6_2: {
                    en: 'Registration required, up to one (1) piece of luggage; maximum 30 kg;<br />any weight exceeded be charged as excess baggage;<br />Sports luggage must be opened at check-in.<br />Fees for sports and special baggage are non-refundable.',
                    de: 'anmeldepflichtig maximal ein (1) Gepäckstück; maximal 30 kg;<br />ab 31. kg Übergepäckrate;<br />Sportgepäck muss am Check-in geöffnet werden.<br />Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.',
                },
                add_row_6_3: {
                    en: '70 EUR',
                    de: '70 EUR',
                },
                add_row_6_4: {
                    en: '150 EUR',
                    de: '150 EUR',
                },
                // >>> ------------------------
                add_row_7_1: {
                    en: 'Canoe, Kayak',
                    de: 'Kanu/Kajak',
                },
                add_row_7_2: {
                    en: 'Registration required, up to one (1) piece of luggage;<br /> maximum 30 kg;<br /> any weight exceeded be charged as excess baggage.<br /> Sports luggage must be opened at check-in.<br /> Fees for sports and special baggage are non-refundable.',
                    de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 30 kg; ab 31. kg Übergepäckrate <br /> Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.',
                },
                add_row_7_3: {
                    en: '70 EUR',
                    de: '70 EUR',
                },
                add_row_7_4: {
                    en: '150 EUR',
                    de: '150 EUR',
                },
                // >>> ------------------------
                add_row_8_1: {
                    en: 'Hangglider/Paraglider',
                    de: 'Hang/Paraglider',
                },
                add_row_8_2: {
                    en: 'Registration required, up to one (1) piece of luggage;<br />  maximum 30 kg;<br />  any weight exceeded be charged as excess baggage.<br />Sports luggage must be opened at checkin.<br />Fees for sports and special baggage are non-refundable.',
                    de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 30 kg; ab 31. kg Übergepäckrate <br /> Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.',
                },
                add_row_8_3: {
                    en: '70 EUR',
                    de: '70 EUR',
                },
                add_row_8_4: {
                    en: '150 EUR',
                    de: '150 EUR',
                },
                // >>> ------------------------
                add_row_9_1: {
                    en: 'Pet in cabin',
                    de: 'Tier in Kabine',
                },
                add_row_9_2: {
                    en: 'Registration required; up to 6 kg incl. box maximum dimensions 42x31x20 cm;<br />only one (1) animal per passenger<br />Please specify animal species and dimensions of the box!<br /> Fees for animal transport are non-refundable.',
                    de: 'anmeldepflichtig; bis maximal 6 kg inkl. Box maximal 42x31x20 cm;<br />je Fluggast nur ein (1) Tier <br />Bitte Tierart und Abmessungen der Box angeben! <br />Gebühren für Tierbeförderung sind nicht erstattungsfähig.',
                },
                add_row_9_3: {
                    en: '60 EUR',
                    de: '60 EUR',
                },
                add_row_9_4: {
                    en: '100 EUR',
                    de: '100 EUR',
                },
                // >>> ------------------------
                add_row_10_1: {
                    en: 'Pet in cargo hold',
                    de: 'Tier im Frachtraum',
                },
                add_row_10_2: {
                    en: 'Registration required; from 7 kg incl. box<br />Please specify animal species and dimensions of the box!<br />Fees for animal transport are non-refundable.',
                    de: 'anmeldepflichtig; ab 7 kg inkl. Box <br />Bitte Tierart und Abmessungen der Box angeben! <br />Gebühren für Tierbeförderung sind nicht erstattungsfähig.',
                },
                add_row_10_3: {
                    en: '80 EUR (up to 20 kg incl. Box)<br />100 EUR (from 21 kg incl. Box)',
                    de: '80 EUR (bis 20 kg inkl. Box)<br />100 EUR (ab 21. Kg inkl. Box)',
                },
                add_row_10_4: {
                    en: '130 EUR (up to 20 kg incl. Box)<br />150 EUR (from 21 kg incl. Box)',
                    de: '130 EUR (bis 20 kg inkl. Box)<br />150 EUR (ab 21. kg inkl. Box)',
                },
                // >>> ------------------------
                add_row_11_1: {
                    en: 'Unaccompanied minor',
                    de: 'Unbegleitetes Kind',
                },
                add_row_11_2: {
                    en: 'Registration required; at the age of 5-11 years<br /> Please fill in the form "unaccompanied minor", sign and carry it in triplicate.<br /> Charges for unaccompanied children are non-refundable.',
                    de: 'anmeldepflichtig; im Alter von 5-11 Jahren<br /> Bitte Formular „Unbegleites Kind“ ausfüllen, unterzeichnen und in 3-facher Ausfertigung mitführen.<br />Gebühren für unbegleitete Kinder sind nicht erstattungsfähig.',
                },
                add_row_11_3: {
                    en: '60 EUR',
                    de: '60 EUR',
                },
                add_row_11_4: {
                    en: '100 EUR',
                    de: '100 EUR',
                },
                // >>> ------------------------
                add_row_12_1: {
                    en: 'Seat reservations',
                    de: 'Sitzplatzreservierungen',
                },
                // >>> ------------------------
                add_row_13_1: {
                    en: 'Standard seats',
                    de: 'Standard seats',
                },
                add_row_13_2: {
                    en: 'Fees for seat reservations are non-refundable.',
                    de: 'Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.',
                },
                add_row_13_3: {
                    en: '15 EUR per person',
                    de: '15 EUR pP',
                },
                add_row_13_4: {
                    en: 'only online',
                    de: 'Nur online',
                },
                // >>> ------------------------
                add_row_14_1: {
                    en: 'Comfort seats',
                    de: 'Comfort seats',
                },
                add_row_14_2: {
                    en: 'Seats in the 1st row<br />Not for the following group of passengers:<br />- infants (not older than 2 years),<br />- expectant mothers,<br />- Persons with limited mobility due to their body size, illness or age<br />- Persons travelling with pets in cabin<br /><br />Fees for seat reservations are non-refundable.',
                    de: 'Sitzplätze in der 1. Reihe<br /><b><u>Nicht</u></b> für folgenden Personenkreis :<br />- Kleinkinder (bis einschließlich 2 Jahre),<br />- werdende Mütter,<br />- Personen, die Tiere in der Kabine mitführen,<br />- Personen, die eingeschränkt mobil sind.<br />- Personen, die durch ihre Körpermaße, Krankheit oder aus Altersgründen eingeschränkt beweglich sind<br /><br />Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.',
                },
                add_row_14_3: {
                    en: '30 EUR per person',
                    de: '30 EUR pP',
                },
                add_row_14_4: {
                    en: '40 EUR per person',
                    de: '40 EUR pP',
                },
                // >>> ------------------------
                add_row_15_1: {
                    en: 'Best seats',
                    de: 'Best seats',
                },
                add_row_15_2: {
                    en: 'Seats from row 2 to row 7<br />Benefits:<br />- In the front of the cabin<br />- Faster embarking and disembarking<br />- Quickly board service<br />- Short distance to the lavatories<br /><br />Fees for seat reservations are non-refundable.',
                    de: 'Sitzplätze in der 2.-7. Reihe<br />Vorteile:<br />- Vorne in der Kabine<br />- Schnelleres Ein- und Aussteigen<br />- Schnellerer Bordservice<br />- Kurze Wege zu den Toiletten<br /><br />Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.',
                },
                add_row_15_3: {
                    en: '20 EUR per person',
                    de: '20 EUR pP',
                },
                add_row_15_4: {
                    en: '30 EUR per person',
                    de: '30 EUR pP',
                },
                // >>> ------------------------
                add_row_16_1: {
                    en: 'Exit seats',
                    de: 'Exit seats',
                },
                add_row_16_2: {
                    en: 'Seats directly at the emergency exit<br /><u>Not</u> for the following group of people:<br />- Children and infants,<br />- expectant mothers,<br />- Persons carrying pets in the cabin<br />- Persons with reduced mobility,<br />- People who are limited in mobility due their body size, illness or age<br />- Persons who do not understand and speak either German or English<br /><br />Fees for seat reservations are non-refundable.',
                    de: 'Sitzplätze direkt am Notausgang<br /><b><u>Nicht</u></b> für folgenden Personenkreis: <br />- Kinder und Kleinkinder,<br />- werdende Mütter,<br />- Personen, die Tiere in der Kabine mitführen,<br />- Personen, die eingeschränkt mobil sind,<br />- Personen, die durch ihre Körpermaße, Krankheit oder aus Altersgründen eingeschränkt beweglich sind, <br />- Personen, die weder die deutsche noch die englische Sprache verstehen und sprechen<br /><br />Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.',
                },
                add_row_16_3: {
                    en: '30 EUR per person',
                    de: '30 EUR pP',
                },
                add_row_16_4: {
                    en: '40 EUR per person',
                    de: '40 EUR pP',
                },
                // >>> ------------------------
                add_row_17_1: {
                    en: '<b>Special meals</b>',
                    de: '<b>Spezialessen</b>',
                },
                // >>> ------------------------
                add_row_18_1: {
                    en: 'Vegetarian meal',
                    de: 'Vegetarisches Essen',
                },
                add_row_18_2: {
                    en: 'vegetarian; without dairy products<br />Fees for special meals are non-refundable.',
                    de: 'vegetarisch; ohne Milchprodukte<br />Gebühren für Spezialessen sind nicht erstattungsfähig.',
                },
                add_row_18_3: {
                    en: '15 EUR',
                    de: '15 EUR je Essen',
                },
                add_row_18_4: {
                    en: 'only online',
                    de: 'Nur online',
                },
               // >>> ------------------------
                add_row_19_1: {
                    en: 'Gluten-free meal',
                    de: 'Glutenfreies Essen',
                },
                add_row_19_2: {
                    en: 'Fees for special meals are non-refundable.',
                    de: 'Gebühren für Spezialessen sind nicht erstattungsfähig.',
                },
                add_row_19_3: {
                    en: '15 EUR',
                    de: '15 EUR je Essen',
                },
                add_row_19_4: {
                    en: 'only online',
                    de: 'Nur online',
                },
               // >>> ------------------------
                add_row_20_1: {
                    en: 'Diabetic meal',
                    de: 'Diabetiker Essen',
                },
                add_row_20_2: {
                    en: 'Fees for special meals are non-refundable.',
                    de: 'Gebühren für Spezialessen sind nicht erstattungsfähig.',
                },
                add_row_20_3: {
                    en: '15 EUR',
                    de: '15 EUR je Essen',
                },
                add_row_20_4: {
                    en: 'only online',
                    de: 'Nur online',
                },
                // >>> ------------------------
                add_row_21_1: {
                    en: '<b>Service fees for flight booking</b>',
                    de: '<b>Entgelte für Serviceleistungen bei Flugbuchungen</b>',
                },
                // >>> ------------------------
                 add_row_22_1: {
                    en: 'Service surcharge for a callcenter booking or rebooking fee (flight date change) ',
                    de: 'Servicezuschlag, der bei einer Callcenter-Buchung oder Umbuchung (Flugdatum) anfällt',
                },
                add_row_22_2: {
                    en: 'Service fees for flight bookings are non-refundable',
                    de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.',
                },
                add_row_22_3: {
                    en: '25 EUR per booking',
                    de: '25 EUR je Buchung',
                },
                // >>> ------------------------
                 add_row_23_1: {
                    en: 'Rebooking fee per person if the date of flight changes within the valid timetable period up to 48 hours before departure',
                    de: 'Umbuchungsgebühr pro Person bei Änderung des Flugdatums innerhalb der gültigen Flugplanperiode bis 48 Stunden vor Abflug',
                },
                add_row_23_2: {
                    en: 'Service fees for flight bookings are non-refundable',
                    de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.',
                },
                add_row_23_3: {
                    en: '35 EUR per person plus price difference to the current fare',
                    de: '35 EUR pP zzgl. Differenz zum aktuellen Flugpreis',
                },
                // >>> ------------------------
                 add_row_24_1: {
                    en: 'Name change per person per booking up to 48 hours before departure (without change of flight date and / or route)',
                    de: 'Namensänderung pro Person pro Buchung bis 48 Stunden vor Abflug(ohne Änderung Flugdatum und/oder Flugstrecke)',
                },
                add_row_24_2: {
                    en: 'Service fees for flight bookings are non-refundable',
                    de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.',
                },
                add_row_24_3: {
                    en: '130 EUR per person per booking',
                    de: '130 EUR pP je Buchung',
                },
                // >>> ------------------------
                 add_row_25_1: {
                    en: 'Cancellation',
                    de: 'Stornierung',
                },
                add_row_25_2: {
                    en: 'Service fees for flight bookings are non-refundable',
                    de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.',
                },
                add_row_25_3: {
                    en: 'Depending on the tariff regulations',
                    de: 'je nach Tarifbestimmungen',
                },
                // >>> ------------------------
                 add_row_26_1: {
                    en: 'Processing fee for cancellations and refund of taxes & fees at non-refundable fares',
                    de: 'Bearbeitungsgebühr für Stornierungen und Rückerstattung der Steuern & Gebühren, bei nicht erstattungsfähigen Tarifen',
                },
                add_row_26_2: {
                    en: 'Service fees for flight bookings are non-refundable',
                    de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.',
                },
                add_row_26_3: {
                    en: '25 EUR per booking',
                    de: '25 EUR je Vorgang',
                },
                // >>> ------------------------
                add_row_27_1: {
                    en: '<b>Service fees for seat and special reservations</b>',
                    de: '<b>Entgelte für Serviceleistungen bei Sitzplatz- und Sonderreservierungen</b>',
                },
                // >>> ------------------------
                 add_row_28_1: {
                    en: 'Service surcharge that accrued from a call center booking or rebooking',
                    de: 'Servicezuschlag, der bei einer CallcenterBuchung oder Umbuchung (Flugdatum) anfällt',
                },
                add_row_28_2: {
                    en: 'Fees for seat and special reservations services are non-refundable',
                    de: 'Gebühren für Serviceleistungen bei Sitzplatz- und Sonderreservierungen sind nicht erstattungsfähig.',
                },
                add_row_28_3: {
                    en: '10 EUR per booking',
                    de: '10 EUR je Buchung',
                },
                // >>> ------------------------
                // >>> ------------------------
                // >>> ------------------------
                add_p_1 : {
                    en: 'Sports equipment not listed here (such as tennis rackets, hockey sticks, etc.) will be carried as part of the free baggage allowance. In addition, an excess baggage fee must be paid.',
                    de: 'Hier nicht aufgeführtes Sportgepäck (wie Tennisschläger, Hockeyschläger, etc.) wird im Rahmen des Freigepäcks befördert. Darüber hinausgehend ist eine Übergepäckgebühr zu entrichten.',
                },
                add_p_2 : {
                    en: 'Registration for additional services can be made up to 48 hours before departure at <a href="/services">Services</a>.',
                    de: 'Anmeldungen für Zusatzleistungen können bis 48 Stunden vor Abflug unter <a href="/services">Services</a> vorgenommen werden.',
                },
                add_p_3 : {
                    en: 'The fees for additional services are payable upon registration and are non-refundable.',
                    de: 'Die Entgelte für Zusatzleistungen sind bei der Anmeldung zu entrichten und sind nicht erstattungsfähig.',
                },
                add_p_4 : {
                    en: 'Passengers who do <u>not</u> make a previous registration can bring their excess baggage, sports and special luggage to the check-in. The decision on the carriage is subject to the capacity of the cargo compartment. In this case the fees are payable at the check-in and they will be higher due to the increased work load (as when registering online).',
                    de: 'Fluggäste, die <u>keine</u> Anmeldung vornehmen, können ihr Über-, Sport- und Sondergepäck zum Check-in mitbringen. Dort wird dann über die Beförderung gemäß Laderaumkapazität entschieden. Die Entgelte sind dann beim Check-in zu entrichten und fallen aufgrund des erhöhten Aufwandes dann höher (als bei Online-Reservierung) aus.',
                },
                // >>> ------------------------
                add_footer_1 : {
                    en: 'Our service team will be pleased to assist you and is available for any further questions:<br />Phone: +49 (0) 30 53 676 791<br />E-mail: <a href="mailto:kundenservice@sundair.com">Kundenservice@Sundair.com</a>',
                    de: 'Unser Serviceteam berät Sie gern und steht für weitere Fragen gern zur Verfügung:<br />Tel. +49 (0)30 53 676 791<br />E-Mail: <a href="mailto:kundenservice@sundair.com">Kundenservice@Sundair.com</a>',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 3px;
            padding-bottom: 30px;
            padding-left: 3px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/additional-services/Home.vue